module.exports = __webpack_public_path__ + "img/defaultImageForSharing.71bfce1f.webp";